import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import NavData from '@/config/data/nav/nav_data.json';
import { programMenuList, programDetail } from '@/network/apis/apiUri';
import useContent from '@/localization/data_export';
import {
  ProgramAnnouncement,
  ProgramAnnouncementView,
  ProgramHome,
  ProgramIntro,
  ProgramPodcast,
  ProgramSendMessage,
  ProgramSendMessageView,
  ProgramTrackList,
  ProgramVod,
  ProgramVodView,
} from './components';
import { transHHmm } from '../common/common_fnc';
import NotFound from '../../not_found';

import './css/radio_program.scss';
import ProgramPhotoGallery from '@/components/photo-gallery';

function RadioProgram(props) {
  const { location, history, mode, isRadioPlay, setIsRadioPlay } = props;

  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const [selBoard, setSelBoard] = useState();
  const [boardView, setBoardView] = useState();

  const [pgmDetail, setPgmDetail] = useState();
  const [menuData, setMenuData] = useState();

  const pathDefine = ({ type, board_id, program_id }) => {
    let basePath = `${NavData['RADIO_MAIN'].path}/${program_id}`;

    if (type === 'program_home') {
      return basePath;
    }
    if (type === 'program_board') {
      return basePath.concat('/board/', board_id);
    }
    if (type === 'episode' || type === 'vod') {
      return basePath.concat('/vod/', board_id);
    }
    if (type === 'host_introduction') {
      return basePath.concat('/intro/', board_id);
    }
    if (type === 'program_photo') {
      return basePath.concat('/photogallery/', board_id);
    }
    if (type === 'radio_tracklist') {
      return basePath.concat('/tracklist/', board_id);
    }
    if (type === 'aod') {
      return basePath.concat('/podcast/', board_id);
    }
    if (type === 'private_board') {
      return basePath.concat('/board/', board_id);
    }
  };

  const programFetch = ({ program_id, nowBoardId, board_name }) => {
    if (pgmDetail?.programId === program_id && menuData) {
      const _selBoard =
        menuData.find((el) => el.boardId === nowBoardId) ||
        menuData.find((el) => el.type === board_name) ||
        menuData.find((el) => el.title.match(/home/gi)) ||
        menuData[0];

      if (_selBoard) setSelBoard(_selBoard);
      else setSelBoard(undefined);
      return;
    }
    programDetail({ program_id, lan_code: mode })
      .then((res) => {
        if (res.status === 200) {
          const { image, title, content, property, is_news_allow } = res.data;
          const pgmScheDule = property.schedule
            .filter((sch) => sch.start_time !== -1)
            .map((sch) => ({
              isAllDay: sch.week.length === 7,
              day: sch.week.length === 1 ? sch.week[0] : `${sch.week[0]} ~ ${sch.week.slice(-1)}`,
              time: `${transHHmm(sch.start_time)} ~ ${transHHmm(sch.start_time + property.running_time)} KST`,
            }));

          setPgmDetail({
            programId: program_id,
            image: image.find((item) => item.type === 'pc').url,
            title: title.find((item) => item.lan_code === mode).text,
            content: content.find((item) => item.lan_code === mode).text,
            onAir: property.is_onair,
            schedule: pgmScheDule,
            isNews: is_news_allow,
          });

          programMenuList({ program_id, lan_code: 'en', is_open_allow: true })
            .then((res2) => {
              if (res2.status === 200) {
                const menuList = res2.data.item.map((item) => ({
                  key: `menu-${item.menu_id}`,
                  title: item.title,
                  boardId: String(item.board_id),
                  programId: item.program_id,
                  type: item.type,
                  link: pathDefine(item),
                }));

                const _selBoard =
                  menuList.find((el) => el.boardId === nowBoardId) ||
                  menuList.find((el) => el.type === board_name) ||
                  menuList.find((el) => el.title.match(/home/gi)) ||
                  menuList[0];

                setMenuData(menuList);
                if (_selBoard) setSelBoard(_selBoard);
                else setSelBoard(undefined);
              }
            })
            .catch(() => setSelBoard(undefined));
        }
      })
      .catch((e) => {
        if (e.response && (e.response.status === 400 || e.response.status === 500)) {
          setPgmDetail('notFound');
        }
      });
  };

  useEffect(() => {
    const [, , program_id, board_name, nowBoardId, board_item_id] = location.pathname.split('/');

    setBoardView(board_item_id);
    if (board_name === 'vod') {
      const searchParams = new URLSearchParams(location.search);
      const _boardId = searchParams.get('board');
      if (_boardId) setBoardView(_boardId);
    }
    programFetch({ program_id, nowBoardId, board_name });
  }, [location]);

  if (pgmDetail === 'notFound') return <NotFound />;
  if (!(pgmDetail && menuData && selBoard)) return null;
  return (
    <div id="RadioProgram" className="radioProgram">
      <Helmet>
        <title>{`${pgmDetail.title} - RADIO | Arirang`}</title>
      </Helmet>
      <section className={`radioProgram_section thumb sub${boardView ? ' vod-mode' : ''}`}>
        <img className="thumb_img" src={pgmDetail.image} alt={pgmDetail.title} />
      </section>
      <section className={`radioProgram_section nav${boardView ? ' style_title' : ''}`}>
        {boardView && <h3 className="nav_title">{pgmDetail.title}</h3>}
        <ul className="nav_listWrap">
          {menuData.map((item) => (
            <li className="list" key={item.key}>
              <Link
                to={item.link}
                className={`link${item.boardId === selBoard.boardId ? ' active' : ''}`}
                title={anchorTitle}
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      </section>

      {selBoard.type.match(/program_home/gi) && <ProgramHome mode={mode} pgmDetail={pgmDetail} menuData={menuData} />}
      {selBoard.type.match(/host_introduction/gi) && (
        <ProgramIntro mode={mode} pgmDetail={pgmDetail} boardId={selBoard.boardId} />
      )}
      {selBoard.type.match(/radio_tracklist/gi) && <ProgramTrackList mode={mode} boardId={selBoard.boardId} />}
      {selBoard.type.match(/aod/gi) && (
        <ProgramPodcast
          mode={mode}
          history={history}
          selBoard={selBoard}
          search={location.search}
          isRadioPlay={isRadioPlay}
          setIsRadioPlay={setIsRadioPlay}
        />
      )}
      {selBoard.type.match(/program_board/gi) && !boardView && (
        <ProgramAnnouncement mode={mode} history={history} selBoard={selBoard} anchorTitle={anchorTitle} />
      )}
      {selBoard.type.match(/program_board/gi) && boardView && (
        <ProgramAnnouncementView mode={mode} history={history} selBoard={selBoard} itemId={boardView} />
      )}
      {selBoard.type.match(/program_photo/gi) && (
        <ProgramPhotoGallery mode={mode} history={history} selBoard={selBoard} />
      )}
      {selBoard.type.match(/private_board/gi) && !boardView && (
        <ProgramSendMessage mode={mode} selBoard={selBoard} history={history} anchorTitle={anchorTitle} />
      )}
      {selBoard.type.match(/private_board/gi) && boardView && (
        <ProgramSendMessageView mode={mode} selBoard={selBoard} history={history} itemId={boardView} />
      )}
      {selBoard.type.match(/vod/gi) && !boardView && <ProgramVod mode={mode} selBoard={selBoard} history={history} />}
      {selBoard.type.match(/vod/gi) && boardView && (
        <ProgramVodView
          mode={mode}
          selBoard={selBoard}
          history={history}
          isRadioPlay={isRadioPlay}
          setIsRadioPlay={setIsRadioPlay}
        />
      )}
    </div>
  );
}
export default RadioProgram;
